import { DefaultFileHandler, FileHandler, InvalidFileException } from "./FileHandler";
import { FileData } from "./FileData";
import plupload from 'plupload';

/**
 * A generic file uploader that takes any file and stores it on the server.
 */
class AnyFileHandler extends DefaultFileHandler implements FileHandler {
  handleError(up: plupload.Uploader, error: plupload_error): void {
    const jsonErr = JSON.parse(error.response);
    if (error.file.id) {
      const fData = this.fileData[error.file.id];
      this.store.dispatch('files/setProgress', {
        reference: fData.file_id,
        progress: -1,
      });
      this.store.dispatch('files/setError', {
        reference: fData.file_id,
        message: jsonErr.errors[0].message
      });
    } else {
      alert(jsonErr.errors.message);
    }
  }

  handleBeforeUpload(up: plupload.Uploader, file: plupload.File): void {

  }

  handleBeforeChunkUpload(up: plupload.Uploader, file: plupload.File, info: any): void {
    const fData = this.fileData[file.id];
    this.store.dispatch('files/setCurrentChunk', {reference: fData.file_id, chunk: info.chunk});
  }

  handleChunkUploaded(up: plupload.Uploader, file: plupload.File, info: any): void {
    const fData = this.fileData[file.id];
    this.store.dispatch('files/syncFromServer', fData.file_id);
  }

  handleFileUploaded(up: plupload.Uploader, file: plupload.File): void {
    super.handleFileUploaded(up, file);

    const fData = this.fileData[file.id];
    this.store.dispatch('files/syncFromServer', fData.file_id).then(() => {
      this.store.dispatch('files/setProgress', {
        reference: fData.file_id,
        progress: 100,
      });

      this.store.dispatch('files/setCurrentChunk', {reference: fData.file_id, chunk: -1});
    });
  }

  handleFilesAdded(up: plupload.Uploader, file: plupload.File): void {
  }

  handlePaused(up: plupload.Uploader, currentFile: plupload.File) {
  }

  handleResume(up: plupload.Uploader, currentFile: plupload.File) {

  }

  handleUploadProgess(up: plupload.Uploader, file: any): void {
    if (file.percent > 99) {
      return; // Let handleFileUploaded mark it as 100
    }

    this.store.dispatch('files/setProgress', {
      reference: this.fileData[file.id].file_id,
      progress: file.percent,
    });
  }

  isFileOfType(file: plupload.File, data: FileData): boolean {
    return data.upload_type === 'file';
  }
}

export default AnyFileHandler;
